module.exports = __webpack_public_path__ + "static/media/luopan_m_game.875de27.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameVideo/luopan_m_game.mp4
// module id = s6er
// module chunks = 0